import React, { useMemo } from "react";
import EChart from "./EChart";
import { ECHART_TOOLTIP, ECHART_TOOLBOX } from "../../Utilities/echartsTheme";
import { formatNumber } from "../../Utilities/numbers";

const monthLabels = (monthStr) => {
  const [year, month] = monthStr.split("-");
  const date = new Date(Number(year), Number(month) - 1, 1);
  return date.toLocaleDateString("en-US", { month: "short", year: "2-digit" });
};

const EChartsTimeSeriesLine = ({ data, label, color = "#3B82F6", valueKey = "value" }) => {
  const option = useMemo(() => {
    if (!data || data.length === 0) return null;

    const labels = data.map((item) => monthLabels(item.month));
    const values = data.map((item) => Number(item[valueKey] || 0));

    return {
      tooltip: {
        ...ECHART_TOOLTIP,
        trigger: "axis",
        formatter: (params) => {
          const p = params[0];
          return `<div style="font-weight:600;margin-bottom:4px">${p.axisValue}</div>${label}: ${formatNumber(p.value)}`;
        },
      },
      toolbox: ECHART_TOOLBOX,
      grid: { left: "3%", right: "5%", bottom: "3%", top: "8%", containLabel: true },
      xAxis: {
        type: "category",
        data: labels,
        boundaryGap: false,
        axisLabel: { hideOverlap: true },
      },
      yAxis: {
        type: "value",
        minInterval: 1,
        axisLabel: { formatter: (v) => formatNumber(v) },
      },
      series: [
        {
          name: label,
          type: "line",
          data: values,
          smooth: true,
          symbol: "circle",
          symbolSize: 6,
          showSymbol: data.length <= 24,
          lineStyle: { width: 2.5, color },
          itemStyle: { color },
          areaStyle: {
            color: {
              type: "linear",
              x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [
                { offset: 0, color: `${color}40` },
                { offset: 1, color: `${color}05` },
              ],
            },
          },
          emphasis: { focus: "series" },
          animationDuration: 800,
        },
      ],
    };
  }, [data, label, color, valueKey]);

  if (!data || data.length === 0) {
    return (
      <div className="d-flex align-items-center justify-content-center h-100 text-muted">
        No data available
      </div>
    );
  }

  return <EChart option={option} />;
};

export default EChartsTimeSeriesLine;
